module.exports = __webpack_public_path__ + "media/images/footer/en_ef-592905f80d5f923907e2e98b056e235b.svg";